<template>
  <div class="mt-2 mb-4 readiness-page">
    <div class="readiness-header">
      Readiness
    </div>
    <ReadinessMenu 
      :menuItems="menuItems" 
      :initialTab="initialTab" 
      @tab-selected="selectTab"
    />
    <div class="readiness-content" v-if="selectedTab === 'Employees'">
      <EmployeesReadinessTab
        :averageReadiness="averageReadiness"
        :last_month_averageReadiness="last_month_averageReadiness"
        :employees="employees"
        :filterGroups="filterGroups"
        :appliedFilters="appliedFilters"
        :searchText="searchText"
        :totalCount="totalCount"
        :currentPage="currentPage"
        :itemsPerPage="itemsPerPage"
        :toggleLoader="toggleLoader"
        @onChatterClick="$emit('onChatterClick', $event)"
        @onSearch="$emit('onSearch', $event)"
        @onFilterChange="$emit('onFilterChange', $event)"
        @onRemoveFilter="$emit('onRemoveFilter', $event)"
        @onClearFilters="$emit('onClearFilters', $event)"
        @onExcludeChange="$emit('onExcludeChange', $event)"
        @onPaginationChange="$emit('onPaginationChange', $event)"
      />
    </div>
    <div class="readiness-content" v-if="selectedTab === 'Organizational'">
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import ReadinessMenu from "@components/ReadinessMenu/ReadinessMenu.vue";
import EmployeesReadinessTab from "@components/EmployeesReadinessTab/EmployeesReadinessTab.vue";
const emit = defineEmits(["tab-selected", "onChatterClick", "onSearch", "onFilterChange", "onRemoveFilter", "onClearFilters", "onExcludeChange", "onPaginationChange"]);

const props = defineProps({
  menuItems: {
    type: Array,
    required: true,
  },
  initialTab: {
    type: String,
    default: "Employees",
  },
  averageReadiness: {
    type: Number,
    default: 0,
  },
  last_month_averageReadiness: {
    type: Number,
    default: 0,
  },
  employees: {
    type: Array,
    default: () => [],
  },
  filterGroups: {
    type: Array,
    default: () => [],
  },
  appliedFilters: {
    type: Array,
    default: () => [],
  },
  searchText: {
    type: String,
    default: "",
  },
  totalCount: {
    type: Number,
    default: 0,
  },
  currentPage: {
    type: Number,
    default: 1,
  },
  itemsPerPage: {
    type: Number,
    default: 10,
  },
  toggleLoader: {
    type: Boolean,
    default: false,
  },
});

const selectedTab = ref(props.initialTab);

const selectTab = (payload) => {
  const label = typeof payload === "string" ? payload : payload?.label;
  if (!label) return;
  selectedTab.value = label;
  emit("tab-selected", label);
};

watch(
  () => props.initialTab,
  (newVal) => {
    selectedTab.value = newVal;
  },
  { immediate: true }
);
</script>

<style scoped>
.readiness-header {
  font-family: Inter;
  font-weight: 600;
  font-size: 30px;
  line-height: 38px;
  color: #101828;
}
</style>
